/* tslint:disable */
/* eslint-disable */
/**
 * Finastic Frontend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegistrationTokenDto
 */
export interface RegistrationTokenDto {
    /**
     * 
     * @type {string}
     * @memberof RegistrationTokenDto
     */
    token?: string | null;
}

export function RegistrationTokenDtoFromJSON(json: any): RegistrationTokenDto {
    return RegistrationTokenDtoFromJSONTyped(json, false);
}

export function RegistrationTokenDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegistrationTokenDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': !exists(json, 'token') ? undefined : json['token'],
    };
}

export function RegistrationTokenDtoToJSON(value?: RegistrationTokenDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
    };
}

